import { passosSwish } from '../../../mocks/worksheet-swish';

export default function PassosSwish() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Os 8 Passos da Técnica Swish
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Siga este protocolo passo a passo para reprogramar seus padrões mentais de forma eficaz
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {passosSwish.map((passo) => (
            <div
              key={passo.numero}
              className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-gray-100 hover:border-purple-200 group"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${passo.cor} rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${passo.icone} text-3xl text-white`}></i>
              </div>
              
              <div className="flex items-center gap-2 mb-3">
                <span className="text-sm font-bold text-purple-600 bg-purple-50 px-3 py-1 rounded-full">
                  Passo {passo.numero}
                </span>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {passo.titulo}
              </h3>
              
              <p className="text-sm text-gray-600 leading-relaxed">
                {passo.descricao}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-br from-purple-50 to-pink-50 rounded-3xl p-8 border-2 border-purple-100">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl flex items-center justify-center flex-shrink-0">
              <i className="ri-lightbulb-flash-line text-2xl text-white"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Dica Importante</h3>
              <p className="text-gray-700 leading-relaxed">
                A velocidade é essencial! Quanto mais rápido você executar o movimento SWISH (passo 5), mais eficaz será a reprogramação. O cérebro aprende melhor com mudanças súbitas e intensas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}